import { render, staticRenderFns } from "./TesseractLightIcon.vue?vue&type=template&id=e25d55aa&"
import script from "./TesseractLightIcon.vue?vue&type=script&lang=ts&"
export * from "./TesseractLightIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports